
const digest = 'd467d18bafd724fd1c00dd1e8c48c79a9cac61d612e17edd201ee0e0a5247c79';
const css = `._speaker_7xst1_1 {
  border-left: 3px solid #ccc;
  padding-left: 15px;
  display: block;
  margin-bottom: 24px;
}

._speakerInfo_7xst1_8 {
  display: block;
  margin-bottom: 8px;
}

._prompt_7xst1_13 {
  font-weight: bold;
  font-size: 1.2em;
  margin-bottom: 16px;
}

._timestamp_7xst1_19 {
  cursor: pointer;
}
`;

(function() {
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"speaker":"_speaker_7xst1_1","speakerInfo":"_speakerInfo_7xst1_8","prompt":"_prompt_7xst1_13","timestamp":"_timestamp_7xst1_19"};
export { css, digest };
  